var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Row, Text } from 'elemental-react';
import { NameText, UsernameText } from './BasePost';
import { getTimeAgo } from '../utils/time';
import ProfileIcon from '../profile/ProfileIcon';
var QuotePost = function (_a) {
    var user = _a.user, createdAt = _a.createdAt, text = _a.text;
    return (_jsxs(Box, __assign({ borderRadius: "6px", borderColor: "#B5B5B5", borderWidth: 1, p: 12, mt: 16 }, { children: [_jsxs(Row, __assign({ justifyContent: "space-between" }, { children: [_jsxs(Row, { children: [_jsx(ProfileIcon, { size: 24, uri: user === null || user === void 0 ? void 0 : user.profile_image_url_https }, void 0),
                            _jsxs(Box, __assign({ ml: "8px" }, { children: [_jsx(NameText, { children: user === null || user === void 0 ? void 0 : user.name }, void 0),
                                    _jsx(UsernameText, { children: "@" + (user === null || user === void 0 ? void 0 : user.screen_name) }, void 0)] }), void 0)] }, void 0),
                    _jsx(Text, __assign({ fontFamily: "Helvetica", fontSize: 16 }, { children: getTimeAgo(createdAt) }), void 0)] }), void 0),
            _jsx(Text, __assign({ mt: "8px" }, { children: text }), void 0)] }), void 0));
};
export default QuotePost;
